module.exports = __webpack_public_path__ + "static/media/documentToken.0232ed89.svg";